export default [
  {
    isDefault: true,
    label: 'Dowód osobisty / E-dowód',
    mask: 'AAA######',
    value: 'id'
  },
  {
    label: 'Paszport Polski',
    mask: 'AA#######',
    value: 'passport'
  },
  {
    label: 'Paszport Zagraniczny',
    mask: '',
    value: 'foreign_passport'
  }
];
